const FIXED_HOLIDAYS = [
  "01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-08", "12-25", "12-26",
];

function easterMonday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  const easter = new Date(Date.UTC(year, month - 1, day));
  easter.setUTCDate(easter.getUTCDate() + 1);
  return `${String(easter.getUTCMonth() + 1).padStart(2, "0")}-${String(easter.getUTCDate()).padStart(2, "0")}`;
}

export function getRomeParts() {
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Rome",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour12: false,
  });
  const parts = fmt.formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const weekdayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return {
    weekday: weekdayMap[get("weekday")],
    hour: parseInt(get("hour"), 10) % 24,
    minute: parseInt(get("minute"), 10),
    md: `${get("month")}-${get("day")}`,
    year: new Date().getFullYear(),
  };
}

export function isHolidayToday() {
  const { md, year } = getRomeParts();
  return FIXED_HOLIDAYS.includes(md) || easterMonday(year) === md;
}

export function isOpenNow() {
  const { weekday, hour, minute } = getRomeParts();
  if (isHolidayToday()) return false;
  if (weekday < 1 || weekday > 5) return false;
  const mins = hour * 60 + minute;
  return (mins >= 8 * 60 && mins < 13 * 60) || (mins >= 14 * 60 && mins < 17 * 60);
}
